<section class="signature-capture">
  <h2 class="sign-hd"> <img src="/assets/images/signature-pen.svg" class="sign-icon"> Capture — Topaz SigLite</h2>

  <p class="status" [class.status-ok]="connected()" [class.status-err]="!sdkAvailable()">
    {{ statusMessage() }}
  </p>

  <canvas #padCanvas width="400" height="150" class="pad-canvas"></canvas>

  <div class="actions">
    <button type="button" (click)="onClear()" [disabled]="!connected()" class="secondary-btn">Clear</button>
    <button type="button" (click)="onSave()" [disabled]="!connected() || saving()" class="primary-btn">
      {{ saving() ? 'Saving…' : 'Submit' }}
    </button>
  </div>
</section>
